import { ScalingReasonCode } from '@cast/types-stop';

export const ACTION_TYPE_TO_DIMENSION_MAP: Record<ScalingReasonCode, string> = {
  [ScalingReasonCode.SCALING_REASON_CODE_UNSPECIFIED]: 'Unknown',
  [ScalingReasonCode.PREEMPTIVE_SIZE_HEADROOM]: 'Unknown',
  [ScalingReasonCode.THROUGHPUT_UNDERUTILIZED]: 'Throughput',
  [ScalingReasonCode.THROUGHPUT_SATURATION]: 'Throughput',
  [ScalingReasonCode.IOPS_UNDERUTILIZED]: 'IOPS',
  [ScalingReasonCode.IOPS_SATURATION]: 'IOPS',
  [ScalingReasonCode.LOW_FREE_SPACE]: 'Size',
};

export const ACTION_TYPE_TO_DIRECTION_MAP: Record<ScalingReasonCode, string> = {
  [ScalingReasonCode.SCALING_REASON_CODE_UNSPECIFIED]: 'reason',
  [ScalingReasonCode.PREEMPTIVE_SIZE_HEADROOM]: 'reason',
  [ScalingReasonCode.THROUGHPUT_UNDERUTILIZED]: 'decrease',
  [ScalingReasonCode.THROUGHPUT_SATURATION]: 'increase',
  [ScalingReasonCode.IOPS_UNDERUTILIZED]: 'decrease',
  [ScalingReasonCode.IOPS_SATURATION]: 'increase',
  [ScalingReasonCode.LOW_FREE_SPACE]: 'increase',
};
